import { BattleshipApiMapper } from './mappers/battleship.api.mapper';
import createHttpClient from './createTimetablesWebApiHttpClient';
import BattleshipMove from '../models/battleship/battleshipMove';
import BattleshipObjectGroup from '../models/battleship/battleshipObjectGroup';
import TimetableSlot from '../models/timetable/timetableSlot';
import moment from 'moment';

class BattleshipApi {
    httpClient;

    constructor() {
        this.httpClient = createHttpClient();
    }

    async GetSubjects() {
        const { data } = await this.httpClient.get(`/battleship/subjects`);
        return data;
    }

    async GetBuildingRooms(buildingId: number) {
        const { data } = await this.httpClient.get(`/battleship/rooms?buildingId=${buildingId}`);
        return data;
    }

    async GetBuildings(schoolId: number) {
        const { data } = await this.httpClient.get(`/battleship/buildings?schoolId=${schoolId}`);
        return data;
    }

    async GetBattleshipInstructors(schoolId: number, termSchoolId: number, setId: number) {
        const { data } = await this.httpClient.get(`/battleship/instructors?schoolId=${schoolId}&termSchoolId=${termSchoolId}&setId=${setId}`);
        return data;
    }

    async GetUpdatedTimetables(termSchoolID: number, objectTypeID: number, objectID: number, week: number, moves: Array<BattleshipMove>) {
        const battleShipChanges = BattleshipApiMapper.mapBattleshipMovesToBattleshipChangeDtos(moves);

        const { data } = await this.httpClient.post(
            `/battleship/GetUpdatedTimetables?termSchoolID=${termSchoolID}&objectTypeID=${objectTypeID}&objectID=${objectID}&week=${week - 1}`,
            battleShipChanges,
        );

        return data;
    }

    async GetGroupTimetables(battleshipObjectGroupList: Array<BattleshipObjectGroup>, moves: Array<BattleshipMove>, termSchoolId: number, week: number) {

        const battleShipChanges = BattleshipApiMapper.mapBattleshipMovesToBattleshipChangeDtos(moves);

        const postDataItem = { changes: battleShipChanges, groups: battleshipObjectGroupList };

        const { data } = await this.httpClient.post(`/battleship/GetGroupTimetables?termSchoolID=${termSchoolId}&&week=${week - 1}`, postDataItem);
        return data;
    }

    async GetOpenTimetableSlots(setTimetableItem: any, timetableChanges: Array<BattleshipMove>, termSchoolId: number, week: number, schoolId: number): Promise<Array<TimetableSlot>> {
        const battleShipChanges = BattleshipApiMapper.mapBattleshipMovesToBattleshipChangeDtos(timetableChanges);

        const postDataItem = { SetTimetableItem: setTimetableItem, Changes: battleShipChanges };

        let timetableSlots: Array<TimetableSlot> = [];
        const { data } = await this.httpClient.post(`/battleship/GetOpenSlots?termSchoolID=${termSchoolId}&week=${week - 1}`, postDataItem);

        if (data && data.length) timetableSlots = data.map((d: { timeIn: string; timeOut: string; dayOfWeek: string }) => new TimetableSlot(d.timeIn, d.timeOut, d.dayOfWeek));

        const wedBreakStartTime = moment.duration('14:30:00');
        const wedBreakEndTime = moment.duration('17:30:00');

        //remove the wednesday break for sob
        if (schoolId === 1) {
            const index = timetableSlots.findIndex(
                (s) =>
                    s.dayOfWeek === 'Wednesday' &&
                    moment.duration(s.timeIn).asMilliseconds() < wedBreakEndTime.asMilliseconds() &&
                    wedBreakStartTime.asMilliseconds() < moment.duration(s.timeOut).asMilliseconds(),
            );
            if (index !== -1) timetableSlots.splice(index, 1);
        }

        return timetableSlots;
    }
}

export default BattleshipApi;
